export default __webpack_public_path__ + "static/media/ndic.572d9865.png";